export const headerDarkColor = "#2C373F";
export const headerLigthColor = "#f7fcff";

export const bodyLigthColor = "#fff";
export const bodyDarkColor = "#363636";

export const textAreaLigth = "#fff";
export const textAreaDark = "#484848";

export const textAreaBorderDark = "#484848";
export const textAreaBorderLight = "#cbcbcb";

export const footerLight = "#01b3ff";
export const footerDark = "#3734F0";

export const textDark = "#000000";
export const textLight = "#EFEFEF";
